import { Toaster } from 'react-hot-toast';

export function ToastProvider() {
  return (
    <Toaster
      position="top-right"
      toastOptions={{
        duration: 4000,
        style: {
          background: '#16213e', // dark-800
          color: '#ffffff',
          border: '1px solid #0f3460', // dark-700
          borderRadius: '8px',
        },
        success: {
          iconTheme: {
            primary: '#6366f1', // primary-500
            secondary: '#ffffff',
          },
        },
        error: {
          iconTheme: {
            primary: '#ef4444', // red-500
            secondary: '#ffffff',
          },
        },
      }}
    />
  );
}

// Re-export toast functions for convenience
export { toast } from 'react-hot-toast';